import { Component, EventEmitter, Input, Output, SimpleChanges, AfterViewChecked, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import moment from 'moment';
import { ModelService } from '../../../../core/services/model/model.service';
import { AlertService } from '../../../../core/services/alert/alert.service';
import { OrdersService } from '../../../../core/services/orders/orders.service';
import { Router, RouterModule } from '@angular/router';
import { copyToClipboard as copyToClipboardUtil } from '../../../../core/utils/clipboard.utils';
import { FUEL_OPTIONS, TRANSMISSION_OPTIONS, DRIVETRAIN_OPTIONS, EMISSIONS_LABEL_OPTIONS } from '../../../../core/constants/vehicle-taxonomies.constants';



@Component({
  selector: 'app-vehicle-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    RouterModule,
    NgSelectModule,
    CommonModule],
  templateUrl: './vehicle-form.component.html',
  styleUrl: './vehicle-form.component.css'
})
export class VehicleFormComponent {
  @Input() campaignData?: any;
  @Input() ladata: any = [];
  @Output() emitDuplicate = new EventEmitter<boolean>();
  @Output() emitChangeBrand = new EventEmitter<string>();

  vehicleForm: FormGroup;
  models: any[] = [];
  brands: any[] = [];
  fuelOptions = FUEL_OPTIONS;
  transmissionOptions = TRANSMISSION_OPTIONS;
  drivetrainOptions = DRIVETRAIN_OPTIONS;
  emissionsLabelOptions = EMISSIONS_LABEL_OPTIONS;

  vehicle_model_id_ = '';
  showAlertLicensePlate = false;
  urlLicensePlate = '';
  showAlertVin = false;
  urlVin = '';
  dealershipData: any = [];
  constructor(private fb: FormBuilder, private modelService: ModelService, private alertService: AlertService, private orderService: OrdersService, private router: Router) {
    this.vehicleForm = this.fb.group({
      vehicle_discount_code: ['', Validators.required],
      colour: ['', Validators.required],
      vehicle: ['', Validators.required],
      vehicle_brand_id: ['', Validators.required],
      vehicle_model_id: ['', Validators.required],
      vehicle_model_year: ['', Validators.required],
      vehicle_trim: ['', Validators.maxLength(150)],
      vehicle_status: ['', Validators.required],
      fuel: ['', Validators.required],
      transmission: ['', Validators.required],
      drivetrain: ['', Validators.required],
      emissions_label: ['', Validators.required],
      power: [null, [Validators.required, Validators.min(1)]],
      doors: [null, [Validators.required, Validators.min(1)]],
      seats: [null, [Validators.required, Validators.min(1)]],
      equipment: [''],
    });
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes['ladata']) {
        this.brands = this.ladata.brands;
        this.dealershipData = this.ladata.dealershipData;
      }

      if (changes['campaignData']) {
        if (this.campaignData) {
          this.refrescarFormulario();
        }
      }
    }
  }


  refrescarFormulario() {
    this.updateFieldAccessibility();
    if (this.models.length === 0) {
      if (this.campaignData.vehicle_brand_id) {
        this.onBrandChange(this.campaignData.vehicle_brand_id);
      }
    }

    for (const key in this.campaignData) {
      const control = this.vehicleForm.controls[key];
      const value = this.campaignData[key];

      if (control) {
        switch (key) {
          case 'delivery_first_expected_date':
            control.setValue(value ? moment(value).format('DD/MM/YYYY') : '');
            break;
          default:
            control.setValue(value);
            break;
        }

      }
    }
    this.alertService.close();

    // Auto-resize equipment textarea after data load
    setTimeout(() => {
      const el = document.getElementById('equipment') as HTMLTextAreaElement;
      if (el) {
        el.style.height = 'auto';
        el.style.height = el.scrollHeight + 'px';
      }
    });
  }

  async onBrandChange(value: any) {
    if (!value) return;
    var brand_reference: any = '';
    if (typeof value === 'string') {
      brand_reference = value;
    } else {
      brand_reference = value.target.value;
    }

    try {
      const data = await this.modelService.getDataByBrand(brand_reference).toPromise();
      this.models = data.data;
      if (brand_reference != this.campaignData.vehicle_brand_id) {
        this.vehicleForm.get('vehicle_model_id')?.setValue('');
      }
    } catch (error) {
      console.error('There was an error!', error);
    }

    if (!this.campaignData.vehicle_brand_id) {
      this.emitChangeBrand.emit(brand_reference);
    }

  }

  updateFieldAccessibility() {

    var rules = this.campaignData?.rules;
    // Deshabilitar todos los campos por defecto
    for (const field in this.vehicleForm.controls) {
      if (this.vehicleForm.controls.hasOwnProperty(field)) {
        this.vehicleForm.get(field)?.disable();
      }
    }

    // Habilitar solo los campos con valor 'w' en las reglas
    for (const field in rules) {
      if (rules.hasOwnProperty(field) && rules[field] === 'w') {
        this.vehicleForm.get(field)?.enable();
      }
    }

  }
  checkUpdateForm(): boolean {
    if (this.vehicleForm.dirty) {
      return true;
    } else {
      return false;
    }
  }
  copyToClipboard(value: string, event: Event): void {
    copyToClipboardUtil(value, event);
  }

  autoResize(event: Event): void {
    const el = event.target as HTMLTextAreaElement;
    el.style.height = 'auto';
    el.style.height = el.scrollHeight + 'px';
  }

  duplicate() {
    this.emitDuplicate.emit(true);
  }

  fillVehicleFormForHelper(option: any) {
    this.vehicleForm.get('vehicle_model_id')?.setValue(option['vehicle_model_id']);
    this.vehicleForm.get('vehicle')?.setValue(option['vehicle']);
    this.vehicleForm.get('vehicle_status')?.setValue(option['vehicle_status']);
    this.vehicleForm.get('vehicle_units')?.setValue(option['vehicle_units']);
    this.vehicleForm.get('vehicle_model_year')?.setValue(option['vehicle_model_year']);
    this.vehicleForm.get('colour')?.setValue(option['colour']);
    this.vehicleForm.get('vehicle_trim')?.setValue(option['vehicle_trim']);
  }

  async onBlurVin(value: string) {
    try {
      const data = await this.orderService.checkVin(this.campaignData.reference, value).toPromise();
      if (data.data) {
        this.showAlertVin = true;
        this.urlVin = data.data.url;
      }
    } catch (error) {
      console.error('There was an error!', error);
    }
  }

  async onBlurLicensePlate(value: string) {
    try {
      const data = await this.orderService.checkLicensePlate(this.campaignData.reference, value).toPromise();
      if (data.data) {
        this.showAlertLicensePlate = true;
        this.urlLicensePlate = data.data.url;
      }
    } catch (error) {
      console.error('There was an error!', error);
    }
  }


}
